(function() {
  'use strict';

  angular.module('esn.people')
    .constant('ESN_PEOPLE_FIELDS', {
      EMAIL_ADDRESS: 'emailaddress'
    });
})();
